import type { AgentCitation } from '@avisoma/agent-core/events';
import { FaFile } from 'react-icons/fa6';
import type { PeekType } from '../../hooks/usePeek';
import { ID } from '../ID';
import { PeekLink } from '../PeekLink';

const PEEK_TYPE: Record<AgentCitation['kind'], PeekType> = {
  document: 'document',
  page: 'page',
  reconstructedDocument: 'reconstructed',
};

const SHAPE = 'inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs';

// A plain click opens the peek dialog, so the drawer and its chat stay mounted;
// a modifier-click still opens the full route.
export function EntityChip({ id, kind }: { id: string; kind?: AgentCitation['kind'] }) {
  const content = (
    <>
      <FaFile className="size-3" />
      <ID id={id} />
    </>
  );

  // Without a kind there is no route to open, so the chip is not a link.
  if (!kind) {
    return (
      <span
        className={`${SHAPE} bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300`}
        title="Unknown entity type"
      >
        {content}
      </span>
    );
  }

  return (
    <PeekLink
      type={PEEK_TYPE[kind]}
      id={id}
      className={`${SHAPE} bg-indigo-50 text-indigo-700 hover:bg-indigo-100 dark:bg-indigo-950/40 dark:text-indigo-300 dark:hover:bg-indigo-900/40`}
      title={`${kind} ${id}`}
    >
      {content}
    </PeekLink>
  );
}
